export interface Coupon {
  id: string;
  title: string;
  created_at: string;
  method: string;
  type: string;
  combinations: string;
  enabled: boolean;
  used: number;
}

export const FETCH_COUPONS_REQUEST = "coupon/fetch/request";
export const FETCH_COUPONS_SUCCESS = "coupon/fetch/success";
export const FETCH_COUPONS_FAILURE = "coupon/fetch/failure";

export const ACTIVATE_COUPON_REQUEST = "coupon/activate/request";
export const ACTIVATE_COUPON_SUCCESS = "coupon/activate/success";
export const ACTIVATE_COUPON_FAILURE = "coupon/activate/failure";

export const DEACTIVATE_COUPON_REQUEST = "coupon/deactivate/request";
export const DEACTIVATE_COUPON_SUCCESS = "coupon/deactivate/success";
export const DEACTIVATE_COUPON_FAILURE = "coupon/deactivate/failure";
